
import { getPath } from '@/router/common'

const baseUrl = {
  title: '地址管理',
  path: 'DeliveryRecord'
}
export default [
  {
    path: getPath('modifyAddr', baseUrl),
    name: 'modifyAddr',
    component: () => import(/* webpackChunkName: "modifyAddr" */ '@/views/deliveryRecord/modifyAddr.vue'),
    meta: {
      title: '修改地址'
    }
  },
  {
    path: getPath('SendDeliverymodify', baseUrl),
    name: 'DeliveryRecord_SendDeliverymodify',
    component: () => import(/* webpackChunkName: "DeliveryRecord_SendDeliverymodify" */ '@/views/deliveryRecord/sendDeliverymodify/index.vue'),
    meta: {
      title: '转二级明细清单'
    }
  },
  {
    path: getPath('index', baseUrl),
    name: 'DeliveryRecord_index',
    component: () => import(/* webpackChunkName: "DeliveryRecord_index" */ '@/views/deliveryRecord/index/index.vue'),
    meta: {
      title: '送货上门'
    }
  },
  {
    path: getPath('Deliverymodify', baseUrl),
    name: 'DeliveryRecord_Deliverymodify',
    component: () => import(/* webpackChunkName: "DeliveryRecord_Deliverymodify" */ '@/views/deliveryRecord/deliverymodify/index.vue'),
    meta: {
      title: '送货明细清单'
    }
  },
  {
    path: getPath('returnToUpstream', baseUrl),
    name: 'DeliveryRecord_returnToUpstream',
    component: () => import(/* webpackChunkName: "DeliveryRecord_returnToUpstream" */ '@/views/deliveryRecord/returnToUpstream/index.vue'),
    meta: {
      title: '回传上游费用'
    }
  },
  {
    path: getPath('ArrangeDelivery', baseUrl),
    name: 'DeliveryRecord_ArrangeDelivery',
    component: () => import(/* webpackChunkName: "DeliveryRecord_ArrangeDelivery" */ '@/views/deliveryRecord/arrangeDelivery/index.vue'),
    meta: {
      title: '送货安排'
    }
  },
  {
    path: getPath('Dispatch', baseUrl),
    name: 'DeliveryRecord_Dispatch',
    component: () => import(/* webpackChunkName: "DeliveryRecord_Dispatch" */ '@/views/deliveryRecord/dispatch/index.vue'),
    meta: {
      title: '配送方案'
    }
  },
  {
    path: getPath('SendMap', baseUrl),
    name: 'DeliveryRecord_SendMap',
    component: () => import(/* webpackChunkName: "DeliveryRecord_SendMap" */ '@/views/deliveryRecord/sendMap/index.vue'),
    meta: {
      title: '配送地图'
    }
  },
  {
    path: getPath('IntelligentDelivery', baseUrl),
    name: 'DeliveryRecord_IntelligentDelivery',
    component: () => import(/* webpackChunkName: "DeliveryRecord_IntelligentDelivery" */ '@/views/deliveryRecord/intelligentDelivery/index.vue'),
    meta: {
      title: '智能送货'
    }
  },
  {
    path: getPath('GenerateDeliveryNote', baseUrl),
    name: 'DeliveryRecord_GenerateDeliveryNote',
    component: () => import(/* webpackChunkName: "DeliveryRecord_GenerateDeliveryNote" */ '@/views/deliveryRecord/generateDeliveryNote/index.vue'),
    meta: {
      title: '生成送货单'
    }
  }
]
